// Settings navigation types
export interface SettingsNavigationItem {
  id: string;
  name: string;
  icon: string;
  path: string;
  badge?: {
    text: string;
    color: string;
  };
}

// Account types
export enum AccountType {
  GUEST = 'guest',
  REGISTERED = 'registered',
  PREMIUM = 'premium'
}

// Settings preferences types
export interface UserPreferences {
  theme: 'light' | 'dark' | 'system';
  notifications: {
    enabled: boolean;
    sound: boolean;
    pomodoro: boolean;
    reminders: boolean;
  };
  language: string;
}

// Settings form data
export interface ProfileSettingsFormData {
  displayName: string;
  photoURL?: string;
}

export interface SecuritySettingsFormData {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
} 